import { AppBar, Box, useMediaQuery, useTheme } from '@mui/material';
import { useAuth, useDictionary, useDispatchApp, useIsDesktop } from 'Hooks';
import { useCallback, useEffect, useState } from 'react';
import { ExpandedBurgerMenuView } from './ExpandedBurgerMenuView';
import { ShrinkBurgerMenuView } from './ShrinkBurgerMenuView';
import { MenuOutro } from './MenuOutro';
import { getBurgerMenuItems } from 'API/Home/burgerMenuItems';
import { setMenuItems } from 'Store/MenuItemsSlice';
import { IBurgerMenuItem } from 'API/Home/burgerMenuItems';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

interface IBurgerMenu {
  top?: string;
}
export const BurgerMenu = ({ top }: IBurgerMenu) => {
  const { isAuth, isOtp } = useAuth();
  const { inProgress } = useMsal();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const isDesktop = useIsDesktop();

  const [expandedMenuItem, setExpandedMenuItem] =
    useState<IBurgerMenuItem | null>(null);

  const dictionary = useDictionary(Dictionary, DICTIONARY.BurgerMenu);

  const theme = useTheme();
  const isScreenXl = useMediaQuery(theme.breakpoints.up('xl'));

  const dispatch = useDispatchApp();

  const initMenuItems = useCallback(async () => {
    const menuItemsResult = await getBurgerMenuItems();
    dispatch(setMenuItems(menuItemsResult));
  }, [dispatch]);

  useEffect(() => {
    if (inProgress === InteractionStatus.None && (isAuth || isOtp))
      initMenuItems();
  }, [inProgress, initMenuItems, isAuth, isOtp]);

  const openMenuBarHandler = () => {
    if (!isOpen && !isScreenXl) setIsOpen(true);
  };

  const isLaptopViewOrClosedMenu = isOpen || isScreenXl;

  return !isDesktop ? null : (
    <>
      {!isScreenXl && isOpen && (
        <Box
          sx={{
            width: '100vw',
            height: '100%',
            position: 'absolute',
            top: '0',
            left: '0',
            backgroundColor: 'transparent',
            zIndex: '9',
          }}
          onClick={() => setIsOpen(false)}
        />
      )}
      <Box
        mt={top}
        width='300px'
        ml={isScreenXl ? '0' : isOpen ? '0' : '-228px'}
        mr={isScreenXl ? '0' : isOpen ? '-228px' : '0'}
        flexShrink={0}
        sx={{
          transition: '0.25s',
        }}
        role='navigation'
        aria-label={dictionary.menuAriaLabel}
      >
        <AppBar
          component={'nav'}
          sx={{
            position: 'sticky',
            width: isLaptopViewOrClosedMenu ? '300px' : '72px',
            height: '100vh',
            zIndex: 1100,
            top: '80px',
            left: '0',
            right: 'auto',
            background:
              'linear-gradient(176.1deg, #081E54 -4.18%, #2860EA 86.07%)',
            transition: '0.25s',
            cursor: !isOpen && !isScreenXl ? 'pointer' : undefined,
            overflowY: 'scroll',
            overflowX: 'visible',
            '::-webkit-scrollbar': {
              display: 'none',
            },
          }}
          onClick={openMenuBarHandler}
          role={'navigation'}
        >
          {isScreenXl ? (
            <ExpandedBurgerMenuView />
          ) : isOpen ? (
            <ExpandedBurgerMenuView
              closeMenu={() => setIsOpen(false)}
              expandedMenuItem={expandedMenuItem}
            />
          ) : (
            <ShrinkBurgerMenuView setExpandedMenuItem={setExpandedMenuItem} />
          )}
          <MenuOutro isLaptopViewOrClosedMenu={isLaptopViewOrClosedMenu} />
        </AppBar>
      </Box>
    </>
  );
};
